import { render, staticRenderFns } from "./BookkeepingSetupButton.vue?vue&type=template&id=5b3b9597&"
import script from "./BookkeepingSetupButton.vue?vue&type=script&lang=ts&"
export * from "./BookkeepingSetupButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports